import { Controller } from '@hotwired/stimulus'
import axios from 'axios'
import Swal from 'sweetalert2'

export default class extends Controller {
  static targets = ['container']

  connect () {
    super.connect()
  }

  disconnect () {
    this.close()
  }

  open (event) {
    event.target.blur()
    this.containerTarget.classList.remove('hidden')
  }

  async postWaitlist (event) {
    try {
      await axios.post('/rental_reservation_waitlists', { reservation_id: event.currentTarget.id })
      this.containerTarget.classList.add('hidden')
      const modal = await Swal.fire({
        title: 'キャンセル待ち登録しました',
        text: '',
        confirmButtonText: 'OK',
        confirmButtonColor: '#40BF6C',
        cancelButtonText: '',
        reverseButtons: true,
        allowOutsideClick: false
      })
      if (modal.isConfirmed) await window.location.reload()
    } catch (error) {
      this.containerTarget.classList.add('hidden')
      const modal = await Swal.fire({
        icon: 'error',
        title: 'キャンセル待ち登録に失敗しました',
        text: '再度お試しください',
        confirmButtonText: 'OK',
        confirmButtonColor: '#40BF6C',
        reverseButtons: true,
        allowOutsideClick: false
      })
      if (modal.isConfirmed) await window.location.reload()
    }
  }

  close () {
    this.containerTarget.classList.add('hidden')
  }

  closeBackground (e) {
    if (e.target === this.containerTarget) {
      this.close(e)
    }
  }
}
